import { useMemo } from 'react';
import { useDorisData } from 'src/utils/Hooks/useDorisData';
import { TrafficResponse } from './useGetTrafficByType';

export interface UseGetTrafficByTypeAndBrandsProps {
  metricType: string;
  fieldName: string;
  brandIds: number[];
  keywords?: string[];
  categoryIds?: number[];
  subcategoryIds?: number[];
  topicIds?: string[];
  resultCount?: number;
  enabled?: boolean;
  additionalParams?: Record<string, any>;
}

/**
 * A hook to fetch traffic data by keywords and specific brands
 * This is used for the combined data fetching step (step 3)
 */
export const useGetTrafficByTypeAndBrands = ({
  metricType,
  fieldName,
  brandIds,
  keywords = [],
  categoryIds,
  subcategoryIds,
  topicIds,
  resultCount = 400,
  enabled = true,
  additionalParams = {}
}: UseGetTrafficByTypeAndBrandsProps) => {
  // Only proceed if we have brandIds
  const hasBrands = brandIds && brandIds.length > 0;

  // Use the generic useDorisData hook
  const { data, isLoading, error } = useDorisData<TrafficResponse>({
    methodName: 'GetTrafficByTypeAndBrands',
    metricType,
    fieldName,
    resultCount,
    brandIds,
    categoryIds,
    subcategoryIds,
    keywords,
    topicIds,
    enabled: enabled && hasBrands,
    additionalParams,
    queryOptions: {
      refetchOnWindowFocus: false,
      staleTime: 60 * 10 * 1000
    }
  });

  return {
    data,
    isLoading,
    error,
    hasBrands
  };
};
